<template>
  <div
    class="logout-notification alert alert-warning position-absolute"
    style="right: 40px; top: 30px; z-index: 12345"
    v-if="show_notification"
  >
    {{ $t("message.logout_counter_message") }}
    <button @click="cancelTimeout" class="btn btn-sm">
      {{ $t("message.cancel") }}
    </button>
  </div>
</template>
<script>
export default {
  name: "logout-counter",
  mounted() {
    this.setTimeInterval();
    document.addEventListener("mousedown", () => {
      this.cancelTimeout();
    });
  },
  methods: {
    cancelTimeout() {
      clearInterval(window.logoutinterval);
      clearInterval(this.timeout);
      this.setTimeInterval();
      this.show_notification = false;
    },
    setTimeInterval() {
      this.timeout = setInterval(
        () => {
          this.show_notification = true;
        },
        24 * 60 * 1000,
      );
      /**
       * automate token renewal
       */
      window.logoutinterval = setInterval(
        () => {
          window.vue.$emit("time-to-logout");
          // window.updateToken()
        },
        29 * 60 * 1000,
      ); // every 29 minutes
    },
  },
  data() {
    return {
      show_notification: false,
      timeout: null,
    };
  },
};
</script>
